import React from "react";
import { joinClasses } from "../../utils/joinClasses";
const sizeMap = {
    "4xs": "size-4",
    "3xs": "size-6",
    "2xs": "size-9",
    xs: "size-12",
    sm: "size-14",
    md: "size-20",
    lg: "size-24",
    xl: "size-28",
    "2xl": "size-40",
};
const themeMap = {
    creator: "text-creator-moderate",
    info: "text-info-moderate",
    none: "",
    premium: "text-premium-moderate",
    primary: "text-primary-moderate",
};
export const Pictogram = ({ className, name, size = "md", theme = "primary", ...props }) => (React.createElement("svg", { ...props, className: joinClasses([
        "shrink-0",
        className,
        sizeMap[size],
        themeMap[theme],
    ]), viewBox: "0 0 200 200", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("use", { href: `assets/pictograms/${name}.svg` })));
